import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CuadroEditableEstadio from './CuadroEditableEstadio.js';
import NombresEstadio from './NombresEstadio.js';
import PartidosEstadio from './PartidosEstadio.js';
import ClubesEstadio from './ClubesEstadio.js';
import MensajeError from '../UI/MensajeError.js';
import MensajeCargando from '../UI/MensajeCargando.js';
import GrillaResponsiva from '../UI/GrillaResponsiva.js';
import { TituloTexto } from '../funciones/Funciones.js';
import { Cuadro } from '../funciones/FuncionesEstadio.js';
import useGetURL from '../../hooks/useGetURL.js';
import styles from './DatosEstadio.module.css';

const DatosEstadio = () => {
  const { id: idEstadio } = useParams();
  const [estadio, setEstadio] = useState(null);
  const { isCargando, erroresGet, fetchData, resetErroresGet } = useGetURL();
  const nombreEstadio = estadio && estadio.nombreComun;

  useEffect(() => {
    document.title = TituloTexto(nombreEstadio);
  }, [nombreEstadio]);

  useEffect(() => {
    resetErroresGet();
  }, [resetErroresGet]);

  useEffect(() => {
    if (idEstadio === null) {
      setEstadio(null);
    } else {
      fetchData('estadios/' + idEstadio, setEstadio);
    }
  }, [fetchData, idEstadio]);

  const onEstadioActualizado = (estadioActualizado) => {
    setEstadio(estadioActualizado);
  };

  return (
    <React.Fragment>
      {idEstadio && !isCargando && (
        <div className={`${styles.fichaEstadio}`}>
          {erroresGet === null && estadio && (
            <React.Fragment>
              <div className={`${styles.tituloEstadio}`}>{nombreEstadio}</div>
              {(() => {
                const items = [
                  {
                    id: 'datos_basicos',
                    componente: (
                      <CuadroEditableEstadio
                        cuadro={Cuadro.DATOS_BASICOS}
                        estadio={estadio}
                        onDatosActualizados={onEstadioActualizado}
                      />
                    ),
                  },
                  {
                    id: 'fechas',
                    componente: <CuadroEditableEstadio cuadro={Cuadro.FECHAS} estadio={estadio} />,
                  },
                  { id: 'clubes', componente: <ClubesEstadio estadio={estadio} /> },
                  {
                    id: 'otro_propietario',
                    componente: (
                      <CuadroEditableEstadio cuadro={Cuadro.OTRO_PROPIETARIO} estadio={estadio} />
                    ),
                  },
                  { id: 'nombres', componente: <NombresEstadio estadio={estadio} /> },
                  { id: 'partidos', componente: <PartidosEstadio estadio={estadio} /> },
                ];
                // Los primeros 5 en columna izquierda, el último en derecha
                return <GrillaResponsiva items={items} columnaSeparada={5} />;
              })()}
            </React.Fragment>
          )}
          <MensajeError errores={erroresGet} />
        </div>
      )}
      <MensajeCargando isCargando={isCargando} />
    </React.Fragment>
  );
};

export default DatosEstadio;
